import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useStateSelector } from 'hooks/useStateSelector';

import PageTitleView from 'components/page-title-view';

const PageTitle = () => {
  const { pathname } = useLocation();
  const menuConfig = useStateSelector((state) => state.home.menuConfig);

  const menuItem = useMemo(() => {
    let id = pathname.replace(/\/(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/g, '');
    let comparator = id.replace(/\//, '');

    return menuConfig.find((menuItem) => comparator === menuItem.Id);
  }, [menuConfig, pathname]);

  return <PageTitleView title={menuItem?.Label || ''} />;
};

export default PageTitle;
